module.exports = __webpack_public_path__ + "static/media/Togedemaru_gaussian2.7ba810cf.png";